import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import { lobIdentifierRegex } from '~/components/ClaimPage/constants';
import { useLob } from '~/components/hooks/useLob';
import { useLobConfiguration } from '~/components/hooks/useLobConfiguration';
import { usePolicy } from '~/components/PolicyContainer';
import { isPolicyNotFound } from '~/Utils';
import { getLobDescription } from '~/Utils/lobUtils';

import GenericClaimBarField from './GenericClaimBarField';

type PolicyNumberProps = {
  displayName?: string;
};

const PolicyNumber = ({ displayName = '{{ lob }} Policy' }: PolicyNumberProps): React.JSX.Element => {
  const { claim } = useClaim();
  const { lob } = useLob();
  const { lobConfigurationsDict } = useLobConfiguration();
  const { policy } = usePolicy();

  const lobName = getLobDescription(lob, lobConfigurationsDict);

  const title = displayName.replace(lobIdentifierRegex, lobName);

  return (
    <GenericClaimBarField
      title={title}
      content={isPolicyNotFound(claim) ? 'Policy Not Found' : policy.policy_number}
      allowWrapping={false}
    />
  );
};

export default PolicyNumber;
